import useSWRMutation from "swr/mutation";
import { Network } from "@/utils/network";
import { zodUnsafeValidate } from "@/utils/zod";
import { InstagramSearch } from "../types";
import { useInstagramSearch } from "./useInstagramSearch";
import { useInstagramSearchLists } from "./useInstagramSearchLists";

interface InstagramSearchListEditProps {
  arg: {
    list: InstagramSearch.List;
    name: string;
  };
}

export const useInstagramSearchListEdit = () => {
  const config = useInstagramSearch((state) => state.config);
  const { mutate } = useInstagramSearchLists();

  return useSWRMutation(
    config.api.editList,
    async (api, { arg: props }: InstagramSearchListEditProps) => {
      const { data } = await Network.post<InstagramSearch.List>(api, {
        id: props.list.id,
        name: props.name,
      });

      return zodUnsafeValidate(InstagramSearch.ListSchema, data);
    },
    {
      onSuccess: (updatedList) => {
        mutate((data) => {
          if (data !== undefined) {
            const lists = data.lists.map((list) => {
              if (list.id === updatedList.id) {
                return {
                  ...list,
                  ...updatedList,
                };
              }

              return list;
            });

            return {
              ...data,
              lists,
            };
          }

          return undefined;
        }, false);
      },
    },
  );
};
